import useCases from "../../features/cases/useCases";
import CaseListDesktop from "../cases/CaseListDesktop";
import { ASTIKA_CONFIG } from "./astikaConfig";

const AstikaDesktop = () => <CaseListDesktop config={ASTIKA_CONFIG} list={useCases()} />;

export default AstikaDesktop;
